import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        userNotificationWindow: {
            telegramFlagNotification: false,
            emailFlagNotification: false,
    
            loadNotifications: false,
            loadAdditionNotifications: false,
            notificationList: []
        },
    }),
    getters: {
        getNotificationWindowLoading(state) {
            return state.userNotificationWindow.loadNotifications
        },
        getNotificationWindowList(state) {
            return state.userNotificationWindow.notificationList
        },
        getNotificationWindowLoadingAddition(state) {
            return state.userNotificationWindow.loadAdditionNotifications
        },
        getTelegramFlagNotification(state) {
            return state.userNotificationWindow.telegramFlagNotification
        },
        getEmailFlagNotification(state) {
            return state.userNotificationWindow.emailFlagNotification
        },
    },
    mutations: {
        setNotificationTelegram(state, options) {
            state.userOptions.notification.telegram = options
        },
        setNotificationWindowLoading(state, options) {
            state.userNotificationWindow.loadNotifications = options
        },
        setNotificationList(state, options) {
            state.userNotificationWindow.notificationList = options
        },
        setNewNotificationToList(state, options) {
            console.log(state.userNotificationWindow.notificationList)
            console.log(options)
            state.userNotificationWindow.notificationList = state.userNotificationWindow.notificationList.concat(options)
            console.log(state.userNotificationWindow.notificationList)
        },
        setNotificationWindowLoadingAddition(state, options) {
            state.userNotificationWindow.loadAdditionNotifications = options
        },
        setEmailFlagNotification(state, options) {
            state.userNotificationWindow.emailFlagNotification = options
        },
        setTelegramFlagNotification(state, options) {
            state.userNotificationWindow.telegramFlagNotification = options
        },
    },
    actions: {
        async getApiNotifications(context) {
            context.commit('setNotificationWindowLoading', true)
            await axios.get('user/notifications/').then(response=>{
              context.commit('setNotificationList', response.data.notification_list)
              context.commit('setTelegramFlagNotification', response.data.telegram_flag)
              context.commit('setEmailFlagNotification', response.data.email_flag)
            }).catch(err=>{
              ElMessage.error('Ошибка выгрузки уведомлений');
            })
            context.commit('setNotificationWindowLoading', false)
        },
        async getApiAdditionsNotifications(context, options) {
            context.commit('setNotificationWindowLoadingAddition', true)
            await axios.get('user/notifications/', {
              params: {
                lastQuery: options
              }
            }).then(response=>{
              context.commit('setNewNotificationToList', response.data.notification_list)
              context.commit('setTelegramFlagNotification', response.data.telegram_flag)
              context.commit('setEmailFlagNotification', response.data.email_flag)
            }).catch(err=>{
              ElMessage.error('Ошибка выгрузки уведомлений');
            })
            context.commit('setNotificationWindowLoadingAddition', false)
        },
    }
}